import { AREAS } from "@/lib/site";

export default function AreaShowcase() {
  return (
    <section
      id="area"
      data-testid="area-section"
      className="relative py-24 md:py-32 bg-bone"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-8">
          <div className="max-w-2xl">
            <p className="overline text-ink" data-testid="area-overline">
              Local · Florida Panhandle
            </p>
            <h2
              data-testid="area-heading"
              className="mt-5 font-display text-ink text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight"
            >
              Florida's Emerald Coast,
              <br />
              <span className="italic text-slate2">in detail.</span>
            </h2>
            <p className="mt-4 text-text2/70 text-sm tracking-wide">
              Okaloosa · Walton · Santa Rosa Counties
            </p>
          </div>
          <p className="md:max-w-md text-text2/80 text-base leading-relaxed">
            Each community on Florida's Emerald Coast — the heart of the Florida
            Panhandle — has its own rhythm. Here's how I help clients match the right
            neighborhood to the right life, and the right financing.
          </p>
        </div>

        <div className="mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {AREAS.map((a, idx) => (
            <article
              key={a.name}
              data-testid={`area-card-${a.name.toLowerCase().replace(/\s/g, "-")}`}
              className="group relative aspect-[3/4] rounded-xl overflow-hidden cursor-pointer transition-transform duration-500 hover:-translate-y-2"
              style={{ transitionDelay: `${idx * 30}ms` }}
            >
              <img
                src={a.image}
                alt={a.name}
                className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-ink/95 via-ink/40 to-transparent" />
              <div className="absolute inset-x-0 bottom-0 p-6">
                <div className="overline text-brass mb-2">
                  {String(idx + 1).padStart(2, "0")} · {a.county}
                </div>
                <h3 className="font-display text-white text-2xl md:text-3xl tracking-tight">
                  {a.name}
                </h3>
                <p className="mt-3 text-white/85 text-sm leading-relaxed">
                  {a.blurb}
                </p>
              </div>
            </article>
          ))}
        </div>

        {/* Also serving — extended community list */}
        <div className="mt-14 pt-10 border-t border-border2 grid grid-cols-1 md:grid-cols-3 gap-8" data-testid="also-serving">
          <div>
            <p className="overline text-ink">Walton County · Also serving</p>
            <p className="mt-3 text-text2 text-sm leading-relaxed">
              Seaside · WaterColor · Rosemary Beach · Alys Beach · Inlet Beach · Grayton Beach · Santa Rosa Beach · Miramar Beach · Point Washington
            </p>
          </div>
          <div>
            <p className="overline text-ink">Santa Rosa County · Also serving</p>
            <p className="mt-3 text-text2 text-sm leading-relaxed">
              Navarre Beach · Gulf Breeze · Milton · Pace · Bagdad · Holley · Midway
            </p>
          </div>
          <div>
            <p className="overline text-ink">Mortgage clients</p>
            <h3 className="mt-3 font-display text-ink text-2xl tracking-tight">
              All 50 States
            </h3>
            <p className="mt-2 text-muted2 text-sm leading-relaxed">
              Buying a second home, vacation rental, or investment property anywhere in the U.S.? Edge Home Finance is licensed nationwide.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
